export default __webpack_public_path__ + "static/media/counter-clockwise.f5e3b87b.svg";